import { UniqueIdentifier } from '@dnd-kit/core';
import React, { ReactNode } from 'react';
import { MaybeNil } from '../../utils/interfaces';

export interface IGridPosition {
  rowIndex: number;
  colIndex: number;
}

export enum DropType {
  ROW = 'ROW',
  COLUMN = 'COLUMN',
}

export interface IRowDropPosition extends Pick<IGridPosition, 'rowIndex'> {
  type: DropType.ROW;
}

export interface IColumnDropPosition extends IGridPosition {
  type: DropType.COLUMN;
}

export type IGridDropPosition = IRowDropPosition | IColumnDropPosition;

export type ICanDropOutcome =
  | { canDrop: true }
  | { canDrop: false; reason: string };

export type IColSpanUpdater = (rowIndex: number, newColSpan: number[]) => void;

export type IRowMinHeightUpdater = (
  rowIndex: number,
  newMinRowHeight: number,
) => void;

export type IGridBorderMenuItemsFactory = (
  position: IGridDropPosition,
) => ReactNode | null;

export interface IDndFlexPrivateContext {
  currentDropPosition: IGridDropPosition | null;
  currentDragHandle: UniqueIdentifier | null;
  setCurrentDragHandle: React.Dispatch<
    React.SetStateAction<UniqueIdentifier | null>
  >;
  currentCanDrop: ICanDropOutcome;
  disabled: boolean;
  borderMenuItemsFactory: MaybeNil<IGridBorderMenuItemsFactory>;
}

export enum GridBorderState {
  Inactive = 'INACTIVE',
  Muted = 'MUTED',
  Draggable = 'DRAGGABLE',
  EnabledDroppable = 'ENABLED_DROPPABLE',
  DisabledDroppable = 'DISABLED_DROPPABLE',
}
